import {NgModule} from '@angular/core';
import {AchievementsServiceProvider} from "./services/achievements-service/achievements-service";

@NgModule({
  providers: [
    AchievementsServiceProvider
  ]
})
export class SellionsAchievementModule {}



// WEBPACK FOOTER //
// ./src/modules/achievement/achievement.module.ts